module.exports = __webpack_public_path__ + "img/editorder.0f083d87.svg";